import React from "react";
import AddEstadoForm from "./AddEstadoForm";

const AddEstado = ({ show, setShow }) => {
  const handleShow = () => {
    setShow(!show);
  };
  return (
    <>
      <div className="">
        <button className="btn btn-dark" onClick={handleShow}>
          {show ? "Ocultar Form" : "Agregar Estado"}
        </button>
      </div>
      {show && (
        <div className="mt-2">
          <AddEstadoForm setShow={setShow} />
        </div>
      )}
    </>
  );
};
export default AddEstado;
